import { AppProps } from '@types'
import { RootErrorFallback } from 'components/common/ErrorComponent'
import { BASE_URL } from 'config/constants'
import 'keen-slider/keen-slider.min.css'
import { inProduction } from 'lib/misc'
import { zodCustomErrorMap } from 'lib/zodCustomErrorMap'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import { useRouter } from 'next/router'
import Script from 'next/script'
import { useEffect } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Provider } from 'react-redux'
import 'styles/index.css'
import { setErrorMap } from 'zod'
import { store } from '../store'

const AppWatcher = dynamic(() => import('components/AppWatcher'), { ssr: false })

const MyApp = ({ Component, pageProps }: AppProps) => {
  let getLayout = Component.getLayout ?? ((page) => page)

  const { asPath } = useRouter()

  useEffect(() => {
    setErrorMap(zodCustomErrorMap('ru'))
  }, [])

  useEffect(() => {
    if (typeof window !== 'undefined' && inProduction) {
      window.ym!(16650304, 'hit', asPath)
    }
  }, [asPath])

  return (
    <>
      <Head>
        <meta
          name='viewport'
          content='width=device-width, initial-scale=1 maximum-scale=1'
        />
        <link rel='preconnect' href={BASE_URL} />
        <link rel='preconnect' href='https://mc.yandex.ru' />
        <link rel='preconnect' href='https://mc.yandex.com' />
      </Head>

      {/* Я.Метрика: stub + ym('init') живут в pages/_document.tsx,
          здесь только src tag.js на lazyOnload — вне TBT-окна Lighthouse.
          Очередь команд из stub'а выполнится, когда tag.js загрузится. */}
      <Script
        id='ya-tag'
        strategy='lazyOnload'
        src='https://mc.yandex.ru/metrika/tag.js'
      />

      {/* <Script id='mango' strategy='afterInteractive'>
        {`(function (w, d, u, i, o, s, p) {
    if (d.getElementById(i)) {
      return;
    }
    w["MangoObject"] = o;
    w[o] =
      w[o] ||
      function () {
        (w[o].q = w[o].q || []).push(arguments);
      };
    w[o].u = u;
    w[o].t = 1 * new Date();
    s = d.createElement("script");
    s.async = 1;
    s.id = i;
    s.src = u;
    s.charset = "utf-8";
    p = d.getElementsByTagName("script")[0];
    p.parentNode.insertBefore(s, p);
  })(
    window,
    document,
    "//widgets.mango-office.ru/widgets/mango.js",
    "mango-js",
    "mgo"
  );
  mgo({ multichannel: { id: 20839 } });`}
      </Script> */}

      <noscript>
        <div>
          <img
            src='https://mc.yandex.ru/watch/51522458'
            style={{ position: 'absolute', left: '-9999px' }}
            alt=''
          />
        </div>
      </noscript>

      <Provider store={store}>
        <ErrorBoundary FallbackComponent={RootErrorFallback}>
          <AppWatcher />
          {getLayout(<Component {...pageProps} />)}
        </ErrorBoundary>
      </Provider>
    </>
  )
}

export default MyApp
